import React from "react";
import AvatarDropDown from "./AvatarDropDown";
import { useLogout } from "pages/Auth/hooks";
import { useCurrentUser } from "components/CurrentUser/hooks";
import { useUserInfo } from "pages/Account/pages/MyProfile/hooks";

interface IProps {}

const AvatarDropDownContainer = (props: IProps) => {
  const { logout } = useLogout();
  const [user] = useCurrentUser({ revalidateOnMount: false });

  const { data } = useUserInfo({ revalidateOnMount: false });

  return <AvatarDropDown onLogout={logout} user={user} info={data} />;
};

export default AvatarDropDownContainer;
